'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var checkAuth = function () {
  var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_ref2) {
    var auth = _ref2.auth,
        history = _ref2.history;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return auth.checkAuth();

          case 3:
            _context.next = 9;
            break;

          case 5:
            _context.prev = 5;
            _context.t0 = _context['catch'](0);

            console.error('checkAuth: ', _context.t0);
            history.push('/login');
            // TODO not 401 throw error

          case 9:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 5]]);
  }));

  return function checkAuth(_x) {
    return _ref.apply(this, arguments);
  };
}();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _lifecycle = require('recompose/lifecycle');

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _setPropTypes = require('recompose/setPropTypes');

var _setPropTypes2 = _interopRequireDefault(_setPropTypes);

var _renderAfter = require('coact-utils/renderAfter');

var _renderAfter2 = _interopRequireDefault(_renderAfter);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var shape = _propTypes2.default.shape,
    object = _propTypes2.default.object,
    func = _propTypes2.default.func;

var enhancer = (0, _compose2.default)((0, _setPropTypes2.default)({
  auth: shape({
    user: object,
    checkAuth: func
  }),
  history: shape({
    push: func
  })
}), (0, _lifecycle2.default)({
  componentDidMount: function componentDidMount() {
    checkAuth(this.props);
  }
}), (0, _renderAfter2.default)(function (_ref3) {
  var user = _ref3.auth.user;
  return !!user;
}));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'requireAuth');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/Main/requireAuth.js
// module id = 1027
// module chunks = 0